import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Refires Meta Pixel PageView on client-side route changes.
// The first PageView is fired by the base code in public/index.html on full load,
// so we skip the initial render to avoid double-counting.
export default function PixelTracker() {
  const { pathname } = useLocation();
  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    if (window.fbq) window.fbq('track', 'PageView');
  }, [pathname]);

  return null;
}
